import { IcoWindows } from "assets/icons";
import favicon from "assets/icons/favicon.png";
import logo from "assets/images/ccr-highwys-logo-wide.svg";
import { Button } from "components";
import { Helmet } from "react-helmet-async";
import { AuthService } from "services/auth";
import { Constants } from "../../../appConstants";

export default function Login() {
	const authService = new AuthService();

	return (
		<>
			<Helmet>
				<title>{`${process.env.REACT_APP_TITLE} - Backoffice - Login`}</title>
				<link rel="shortcut icon" href={favicon} type="image/x-icon" />
				<link rel="icon" href={favicon} type="image/x-icon" />
			</Helmet>
			<div className="h-full w-full flex justify-center bg-neutral-low-pure-500">
				<div className="flex flex-col gap-16 mt-[20vh] items-center">
					<img src={logo} alt="logo-icon" className="logo" />

					<div className="bg-neutral-high-pure-50 p-10 w-[26.5rem] rounded-lg max-sm:w-[18rem] max-sm:py-6">
						<p className="text-2xl leading-5 font-semibold pb-4">
							{Constants.strings.pages.login.getInto}
						</p>
						<p className="pb-6 text-sm">
							{Constants.strings.pages.login.access}
						</p>
						<Button
							styled="secondary"
							kind="default"
							size="medium"
							hasPadding={false}
							cssClass="w-full sm:mb-3 h-fit md:h-12"
							onClick={authService.login}
						>
							<div className="flex w-full">
								<span className="p-2 border-r-[1px] border-neutral-low-pure-500">
									<IcoWindows />
								</span>
								<span className="flex items-center justify-center w-full">
									{Constants.strings.pages.login.continueMicrosoft}
								</span>
							</div>
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}
